import { render, staticRenderFns } from "./ChatSetup.vue?vue&type=template&id=22f32b5a&"
import script from "./ChatSetup.vue?vue&type=script&lang=js&"
export * from "./ChatSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports